define(function(require) {
  // general
  const CN = require('civicsUtils/constants');
  const CommonReviewCode = require('civicsViews/assign_review/common/common');
  // templates
  const tpl = require('civicsViews/problems/templates/t_cpv_problems.hbs');
  // views
  const itemView = require('civicsViews/problems/v_itv_problem_item');
  const EmptyView = require('civicsViews/problems/v_itv_problem_empty');

  return Marionette.CompositeView.extend({
    initialize:function(options){
      this.config = options.config;
      this.currentSort = options.currentSort;
      this.showAllItems = options.showAllItems;
      this.expanded = options.expanded;
    },
    template:tpl,
    childView: itemView,
    emptyView: EmptyView,
    childViewContainer: function() {
      // The target (in the composite view) for the item rows
      return '.activity-problems-item-view'
    },
    childViewOptions:function(model,index) {
      return {
        config: this.config,
        showAllItems: this.showAllItems,
        index: index,
        expanded: this.expanded
      };
    },
    className: 'activity-problem-table list-view collapsible-wrapper',
    ui: {
      btnSortProblemCode: '.sort-problem-code',
      btnSortResolution: '.sort-problem-resolution',
      iconSortProblemCode: '.sort-problem-code .sort-arrow',
      iconSortResolution: '.sort-problem-resolution .sort-arrow',
      showMore: '.view-more',
      pageReference: '.problem-page-reference',
    },
    events:{
      'click @ui.btnSortProblemCode': 'sortByProblemCodeClicked',
      'click @ui.btnSortResolution': 'sortByResolutionClicked'
    },
    onRender: function () {
      if(__DEV__) console.log('cpv_problems onRender');

      if (this.currentSort.field == 'description') {
        this.ui.iconSortProblemCode.addClass('down');
        this.ui.iconSortProblemCode.removeClass('up');
        this.ui.iconSortProblemCode.closest('.col').attr('aria-sort','ascending');
        this.ui.iconSortResolution.closest('.col').removeAttr('aria-sort');
        if (this.currentSort.direction == CN.SORT_ASC) {
          this.ui.iconSortProblemCode.addClass('up');
          this.ui.iconSortProblemCode.removeClass('down');
          this.ui.iconSortProblemCode.closest('.col').attr('aria-sort','ascending');

        }
      }
      if (this.currentSort.field == 'resolutionDescription') {
        this.ui.iconSortResolution.addClass('down');
        this.ui.iconSortResolution.removeClass('up');

        this.ui.iconSortResolution.closest('.col').attr('aria-sort','ascending');
        this.ui.iconSortResolution.closest('.col').removeAttr('aria-sort');

        if (this.currentSort.direction == CN.SORT_ASC) {
          this.ui.iconSortResolution.addClass('up');
          this.ui.iconSortResolution.removeClass('down');
          this.ui.iconSortResolution.closest('.col').attr('aria-sort','descending');
        }
      }
      if (this.collection.length <= 3) {
        this.ui.showMore.hide();
      }

      if(this.showPageReference()){
        this.$el.addClass('show-page-reference');
      }

      this.$el.rhythmThemeInit();
    },
    sortByProblemCodeClicked: function () {
      if(__DEV__) console.log('cpv_problems sortByProblemCodeClicked');
      this.currentSort.field = 'description';
      this.currentSort.direction = this.ui.iconSortProblemCode.hasClass('up') ? CN.SORT_DESC : CN.SORT_ASC;
      this.collection.sort(this.currentSort.field, this.currentSort.direction);
      // need to manually call render since the collection is not a "real" backbone collection
      // but rather it was retrieved from a model.get
      this.render();
    },
    sortByResolutionClicked: function () {
      if(__DEV__) console.log('cpv_problems sortByResolutionClicked');
      this.currentSort.field = 'resolutionDescription';
      this.currentSort.direction = this.ui.iconSortResolution.hasClass('up') ? CN.SORT_DESC : CN.SORT_ASC;
      this.collection.sort(this.currentSort.field, this.currentSort.direction);
      // need to manually call render since the collection is not a "real" backbone collection
      // but rather it was retrieved from a model.get
      this.render();
    },
    showPageReference: function(){
      var profile = (this.config.isPublic) ? 'public' : (this.config.isCustomer) ? 'customer' : (this.config.isProvider) ? 'provider' : '';
      var electronicPlanConfig = this.config.globalConfig.electronicPlanAttributes;
      
      var hasPageReference = ((this.collection.models.length > 0 && this.collection.models[0].has('pageReference')) || this.collection.models.length == 0);

      return (hasPageReference && 
              electronicPlanConfig != undefined && electronicPlanConfig.hasOwnProperty(profile) && 
              electronicPlanConfig[profile].indexOf('PageReference') != '-1');
    },
    
    templateHelpers:function(){
      var self = this;
      var helpers = {
        showComments: function() {
          return !self.config.isPublic;
        },
        hasProblems: () => !this.collection.isEmpty(),
        showPageReference: this.showPageReference(),
      };
      return helpers;
    }
  });
});
